import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
import { StatisticsTableDescription } from '~/InfoCard/Details/StatisticsTableDescription';
var parseThousands = function (number) {
    return number !== undefined ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 'No data';
};
var Cell = function (_a) {
    var cellData = _a.cellData;
    if (cellData === null) {
        return <UITable.Cell singleLine>-</UITable.Cell>;
    }
    var multiple = cellData.length > 1;
    if (!multiple) {
        return (<UITable.Cell singleLine textAlign='right'>
				{parseThousands(cellData[0].value)}
			</UITable.Cell>);
    }
    else {
        // tslint:disable-line:unnecessary-else
        return (<UITable.Cell singleLine>
				{cellData.map(function (record, i) { return (<div key={i}>{"".concat(record.label, ": ").concat(parseThousands(record.value))}</div>); })}
			</UITable.Cell>);
    }
};
export var MonthlyMultiValue = function (_a) {
    var detail = _a.detail, headers = _a.headers, yearCounter = _a.yearCounter, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group>
			<UITable celled striped structured unstackable className='sticky-column-1' size='small'>
				<UITable.Header>
					<UITable.Row>
						<UITable.HeaderCell />
						{Object.entries(yearCounter).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (<UITable.HeaderCell colSpan={value} key={key} textAlign='center'>
								{key}
							</UITable.HeaderCell>);
        })}
					</UITable.Row>
					<UITable.Row>
						<UITable.HeaderCell data-testid='record-header'>Balení</UITable.HeaderCell>
						{headers.map(function (header) { return (<UITable.HeaderCell data-testid='record-header' key={header} textAlign='center'>
								{new Intl.DateTimeFormat('cs-CZ', { month: 'long' }).format(new Date(header))}
							</UITable.HeaderCell>); })}
					</UITable.Row>
				</UITable.Header>
				<UITable.Body>
					{detail.statistics.map(function (statistics, j) { return (<UITable.Row data-testid='record' key={j}>
							<UITable.Cell singleLine>{statistics.title}</UITable.Cell>
							{headers.map(function (header) {
                var _a;
                return (<Cell cellData={(_a = statistics.records[header]) !== null && _a !== void 0 ? _a : null}/>);
            })}
						</UITable.Row>); })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
		<StatisticsTableDescription />
	</div>);
};
